/**
 * @override King Living: CONTENTFUL_METADATA with HeroBanner CF-04 fields (backgroundColour, textColour, headingImage).
 * Base from pwa-contentful via relative path to avoid overlay circular resolution.
 */
/* eslint-disable node/no-relative-package-imports -- overlay base from pwa-contentful */
import {CONTENTFUL_METADATA as BASE_METADATA} from '../../../pwa-contentful/app/contentful/metadata';

export const CONTENTFUL_METADATA = {
  ...BASE_METADATA,
  HeroBanner: {
    ...BASE_METADATA.HeroBanner,
    fields: [
      'sys',
      'appearance',
      'backgroundColour',
      'backgroundMedia',
      'body',
      'cta',
      'headingImage',
      'headingTitle',
      'rightCta',
      'subtitle',
      'textColour',
      'title'
    ],
  },
  SplitPanelDoubleImageBlock: {
    ...BASE_METADATA.SplitPanelDoubleImageBlock,
    fields: [
      'backgroundColour',
      'contentCollection',
      'mediaPosition',
      'primaryImage',
      'sys',
      'textColour',
      'title'
    ],
  },
  MediaWithScrollableText: {
    ...BASE_METADATA.MediaWithScrollableText,
    fields: [
      'sys',
      'title',
      'backgroundMedia',
      'backgroundMediaMobile',
      'scrollableTextCollection'
    ],
  },

  /**
   * Slim page queries only return sys for blocks; refetch fills nested data. Requiring every
   * legacy field (body, cursor collections, etc.) keeps isComplete false if the API omits keys.
   * Slides only need imagesCollection (and sys).
   */
  MediaCarousel: {
    ...BASE_METADATA.MediaCarousel,
    fields: ['sys', 'imagesCollection'],
  },

  /** List pages only return scalars; refetch loads main + thumb images (hook defaults to `full`) */
  KingDifferenceMediaCf013: {
    ...BASE_METADATA.KingDifferenceMediaCf013,
    fields: ['sys', 'autoplay', 'mainImagesCollection', 'thumbnailImagesCollection', 'text1', 'text2', 'text3', 'title'],
  },

  GlobalConfig: {
    ...BASE_METADATA.GlobalConfig,
    fields: [
      ...(BASE_METADATA.GlobalConfig?.fields || []),
      'accountSuggestedForYou',
      'accountGetInspired',
      'accountOrderHistoryFaq',
      'accountShopNowLink',
    ],
  },

  Blog: {
    ...BASE_METADATA.Blog,
    fields: [
      'sys',
      'author',
      'blogContent',
      'blogHeaderMedia',
      'datePublished',
      'description',
      'title',
    ],
  },

  AccordionPanel: {
    ...BASE_METADATA.AccordionPanel,
    fields: ['sys', 'accordionsCollection', 'title', 'isFaq'],
  },
};
